import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { MaritalStatus } from './marital-status.interface';

export class MaritalStatusService {
   async getMaritalStatuses() {
      return await http.get<Array<MaritalStatus>>(`/marital-statuses`, cacheFirstConfig).then((response) => response.data);
   }
}
